import {_AbstractConstructor, _Constructor} from '@angular/material/core';
import {Subject, Observable} from 'rxjs';
import {OnDestroy} from '@angular/core';

export interface HasWithDestory {
  ngUnsubscribe$: Observable<void>;
  ngOnDestroy(): void;
}

export type CanWithDestroy = object;

export type HasWithDestroyCtor = _Constructor<HasWithDestory> & _AbstractConstructor<HasWithDestory>;

// export function mixinHasDestroy<T extends _AbstractConstructor<HasWithDestory>>(base: T): HasWithDestroyCtor & T;

export function mixinHasDestroy<T extends _Constructor<CanWithDestroy> | _AbstractConstructor<CanWithDestroy>>(
  base: T
): HasWithDestroyCtor & T {
  return class extends base implements OnDestroy {
    protected ngUnsubscribe: Subject<void>;
    ngUnsubscribe$: Observable<void>;

    constructor(...args: any[]) {
      super(...args);
      if (!this.ngUnsubscribe) {
        this.ngUnsubscribe = new Subject();
        this.ngUnsubscribe$ = this.ngUnsubscribe.asObservable();
      }
    }
    ngOnDestroy(): void {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  };
}
const defaultClass = class {};
// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/ban-types
type WithDestroyFn = <T extends _Constructor<object> | _AbstractConstructor<object> = new (...args: any[]) => typeof defaultClass>(
// =======
// type WithDestroyFn = <T extends _Constructor<object> | _AbstractConstructor<object> = typeof defaultClass>(
// >>>>>>> FRNTOFF-10496 PO Signature
  base?: T
) => HasWithDestroyCtor & T;

export const WithDestroy: WithDestroyFn = (base?) => (base ? mixinHasDestroy(base) : mixinHasDestroy(class {})) as unknown as any;
